import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Link as MuiLink } from '@mui/material';
import * as R from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
export var RouterLink = /*#__PURE__*/R.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(MuiLink, _objectSpread(_objectSpread({
    component: ReactRouterLink,
    ref: ref
  }, props), {}, {
    sx: mergeSxProps({
      fontWeight: function fontWeight(theme) {
        return theme.typography.fontWeightBold;
      },
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    }, props.sx)
  }));
});